import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">

                                            <div className="border_subtitle">This tool can help</div>
                                            <p>To enable us to communicate effectively, we need to be able to
                                                call on a number of different skills. Whilst we all like to
                                                think we can communicate well, there can be more to this than we
                                                initially think! This tool is about <span
                                                    className="brown brownbold">how to communicate effectively</span> and
                                                will help you to make your message clear, concise and easily
                                                understood. This will help you communicate more successfully to
                                                a wider range of people with different backgrounds.</p>


                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">COMMUNICATING YOUR MESSAGE</span>
                                            </div>
                                            <p>If we can’t communicate effectively we’re unlikely to get what we
                                                want, whether that’s a train ticket to the right place or
                                                persuading a group of people to commit to a new project. In any
                                                situation, the first things to think about are who you’re
                                                talking to and what you want – then, how you’re most likely to
                                                achieve it.</p>
                                            <div className="innovativeimg">
                                                <img className="" style={{maxWidth:'100%'}}
                                                     src={require('@images/brain-image.png')}
                                                     alt=""/>
                                            </div>
                                            <div className="border_subtitle">Message</div>
                                            <p>First, the type of message you’re trying to get across will
                                                determine the way you go about it. You might have several
                                                important messages to communicate to an uninterested audience –
                                                a group of bored schoolchildren, perhaps – which, instead of
                                                listing, you could more effectively incorporate in a story. You
                                                also need to remember the result you want; for example, if
                                                you’re trying to sell something, don’t forget to tell people how
                                                to place an order!</p>
                                            <div className="border_subtitle">Audience</div>
                                            <p>You need to tailor your message to the audience and their
                                                knowledge of your subject. There’s been much research into the
                                                effect of the tone we use when communicating, which has produced
                                                a theory called ‘Transactional Analysis’.<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>3</sup></a> The
                                                theory is that we have three modes of behaving and
                                                communicating: Parent, Child and Adult – and that we tend to
                                                respond in ways which take their cue from whichever tone of
                                                speech or behaviour is used towards us. So, if someone speaks to
                                                us in the authoritative manner of a Parent we’ll respond with
                                                the typical deference of a Child.</p>
                                            <p>Conversely, if someone opens an interaction in a ‘Child’ manner,
                                                we’re more likely to adopt an authoritative response by assuming
                                                control or giving instruction. However, when interacting in the
                                                workplace we may aim to adopt an ‘Adult’ tone, which is used for
                                                exchanging information, evaluating and decision making. Make
                                                sure, therefore, that you don’t come across as condescending or
                                                critical. ‘Adult’ interactions are characterised by a confident
                                                and inquiring tone, interested and thoughtful body language and
                                                an open, evaluative attitude.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }